<template>
  <div
    v-if="gettingHostMemory"
    class="p-4 analytics-loading"
  >
    <b-spinner variant="primary" />
  </div>
  <div v-else>
    <vue-apex-charts
      ref="memoryAnalytics"
      type="bar"
      :options="options"
      :height="showLegend ? 340 : 240"
      :series="series"
    />
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'MemoryChart',
  components: { VueApexCharts },
  props: {
    capacity: {
      type: Number,
      required: true,
    },
    showLegend: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      id: null,
    }
  },
  computed: {
    gettingHostMemory() {
      return this.$store.state.observability.gettingHostMemory
    },
    hostMemory() {
      return this.$store.state.observability.hostMemory
    },
    used() {
      return this.hostMemory
        ? this.hostMemory.map(val => this.getLineChartValue(val, 'used'))
        : []
    },
    buffer() {
      return this.hostMemory
        ? this.hostMemory.map(val => this.getLineChartValue(val, 'buffer'))
        : []
    },
    cached() {
      return this.hostMemory
        ? this.hostMemory.map(val => this.getLineChartValue(val, 'cached'))
        : []
    },
    series() {
      return [
        {
          data: this.used.map(el => el.count),
          name: 'Used',
        },
        {
          data: this.cached.map(el => el.count),
          name: 'Cached',
        },
        {
          data: this.buffer.map(el => el.count),
          name: 'Buffer',
        },
      ]
    },
    options() {
      return {
        chart: {
          id: 'mc',
          zoom: { enabled: false },
          type: 'bar',
          stacked: true,
          group: 'social',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        legend: {
          show: this.showLegend,
          position: 'bottom',
          itemMargin: {
            horizontal: 5,
            vertical: 15,
          },
        },
        colors: ['#7474BF', '#348AC7', '#E684AE'],
        fill: {
          opacity: 1,
          type: 'line',
        },
        xaxis: {
          labels: {
            offsetY: 5,
            style: {
              fontSize: '0.857rem',
            },
            axisBorder: {
              show: false,
            },
            tickPlacement: 'on',
          },
          categories: this.used.map(el => el.name),
          tickAmount: 5,
          crosshairs: {
            show: false,
            width: 1,
          },
        },
        yaxis: {
          labels: {
            minWidth: 40,
            style: {
              fontSize: '0.857rem',
            },
            formatter: val => this.formatBytes(Number(val), 2),
          },
          tickAmount: 5,
          min: 0,
          max: this.capacity,
        },
        tooltip: {
          followCursor: true,
          shared: true,
          inverseOrder: true,
          intersect: false,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '100%',
            rangeBarGroupRows: true,
          },
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
      }
    },
  },
  created() {
    this.id = this.$route.params.id
    this.$store.dispatch('observability/getHostMemory', this.id).catch(err => {
      console.log(err)
    })
  },
  methods: {
    getLineChartValue(el, val) {
      return {
        name: this.findName(el.timestamp),
        count: el.value[val],
      }
    },
    findName(name) {
      const d = new Date(name)
      return `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
    },
  },
}
</script>

<style lang="scss" scoped>
.analytics-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 240px;
}
</style>
